import { connect } from "react-redux";
import Nav from "../components/Nav";

const mapStateToProps = state => ({
   menuItems: state.get('menuItems')
});

const mapDispatchToProps = dispatch => ({
    
})

export default connect(mapStateToProps, mapDispatchToProps)(Nav);


// WEBPACK FOOTER //
// ./src/containers/Nav.js